import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log({ response })

  const data = isSuccessResponse(response)
  return data?.map((item: any) => ({
    id: item?.id,
    key: item?.key,
    data: {
      type: 'excelFile',
      id: '' + item?.object?.packageId,
      fileName: item?.object?.fileName ?? '',
      rules: item?.object?.rules ?? '',
    },
    type: item?.type,
    className: item?.className,
    username: item?.username,
    approvalStatus: item?.approvalStatus,
    approvalType: item?.approvalType,
  }))
}

const getGEFilePendingApprovals = (elevated: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.pendingApprovalsOfFiles),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getGEFilePendingApprovals }
